<div class="sc-form-control-error form-control-error">
    <ul class="sc-form-control-error__list" *ngIf="shouldShowErrors()">
        <li class="sc-form-control-error__list-item" *ngFor="let error of errorsList">{{ error }}</li>
    </ul>
</div>